import { useEffect } from 'react';
import axios from 'axios';
var useFilesUpload = function () {
    useEffect(function () {
        var fileUploadId = axios.interceptors.request.use(function (config) {
            if (!config.data || typeof config.data !== "object" || !config.data.files)
                return config;
            var data = {};
            var formData = new FormData();
            for (var key in config.data) {
                var element = config.data[key];
                if (element instanceof File) {
                    formData.append('FilesHandler', element, key);
                }
                else {
                    data[key] = element;
                }
            }
            formData.append('data', JSON.stringify(data));
            config.data = formData;
            return config;
        });
        return function () {
            axios.interceptors.request.eject(fileUploadId);
        };
    }, []);
};
export default useFilesUpload;
//# sourceMappingURL=useFilesUpload.js.map